/**
 * Communicate an important and usually
 * time-sensitive message to the user.
 * @param {string} message
 */
function processAlertMessage(message, polite) {
    const $alertMessage = $('#alertMessage');

    // check if message exist
    if (typeof message !== 'string' || message.length === 0) {
        console.error('Please provide a valid alert message : ', message);
        return;
    }

    if(polite) {
        $alertMessage.attr('aria-live', 'polite');
    }

    // Inject the new alert message
    // Note that if you need to fire the same alert multiple times
    // (i.e. the content you're dynamically inserting is the same as before),
    // this generally won't be seen as a change and will not lead to an announcement.
    // For this reason, it's usually best to briefly "clear" the contents of the alert container
    $alertMessage.text('');
    // before then injecting the alert message.
    setTimeout(() => {
        $alertMessage.text(message);
    }, 1);
}

module.exports = {
    processAlertMessage: processAlertMessage,
};